<template>
  <div class="tuolele-main-box sort-management-detail">
    <div class="tuolele-main-search">
      <el-button
        type="primary"
        @click="isShowModal = true"
      >添加分类内容</el-button>
      <el-button
        type="danger"
        @click="deleteArticle((removeMultipleSelection = removeAll))"
      >批量移除</el-button>
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        border
        stripe
        @selection-change="handleDirectorySelectionChange"
      >
        <el-table-column type="selection" width="100px" />
        <el-table-column type="index" label="排序" width="150px">
          <template slot-scope="scope">
            <span v-text="scope.$index + 1" />
          </template>
        </el-table-column>
        <el-table-column prop="title" label="内容标题" />
        <el-table-column prop="type" label="内容类型">
          <template slot-scope="scope">
            <span v-text="scope.row.type == '1' ? '图文' : '视频'" />
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="添加时间" />
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="sortArticle(scope.row)"
            >排序</el-button>
            <el-button
              type="text"
              @click="editArticle(scope.row)"
            >编辑</el-button>
            <el-button
              class="el-button--delete"
              type="text"
              @click="deleteArticle((removeMultipleSelection = [scope.row.id]))"
            >移除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="isShowModal" class="add-content-box">
      <div class="add-content-bg" />
      <div class="center-self add-content">
        <div class="fn-clear add-header">
          <div class="fn-left title">添加分类内容</div>
          <div class="fn-right close" @click="isShowModal = !isShowModal">
            <img :src="closeBtn" alt>
          </div>
        </div>
        <div class="add-content-main">
          <div>
            <el-input
              v-model="searchTitle"
              class="input1"
              placeholder="请输入搜索内容"
            />
            <el-button
              type="primary"
              class="el-button-confirm"
              @click="searchArticle"
            >搜索</el-button>
          </div>
          <div class="add-content-table">
            <el-table
              :data="tableData1"
              tooltip-effect="dark"
              border
              max-height="200"
              style="width: 100%"
              @selection-change="handleArticleSelectionChange"
            >
              <el-table-column type="selection" width="40" />
              <el-table-column
                prop="title"
                label="内容标题"
                width="300"
              />
              <el-table-column prop="type" label="内容类型" width="220">
                <template slot-scope="scope">
                  <span v-text="scope.row.type == '1' ? '图文' : '视频'" />
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="confirm-btn">
            <div class="title">
              已选择
              <span>{{ addMultipleSelection.length }}</span>个内容
            </div>
            <el-button
              type="primary"
              class="el-button-confirm"
              @click="addArticle"
            >确认</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SortManagementDetail',
  components: {},
  data() {
    return {
      closeBtn: require('@/assets/img/close-blue.png'),
      tableData: [],
      tableData1: [],
      isShowModal: false,
      searchTitle: '',
      removeAll: [],
      removeMultipleSelection: [], // 移出的分类
      addMultipleSelection: [], // 添加的分类
      mainId: ''
    }
  },
  mounted() {
    this.getArticleListByDirectory()
  },
  methods: {
    getArticleListByDirectory() {
      const id = this.$route.query.id
      const params = {
        directory_id: id
      }
      this.mainId = id
      this.$http.getArticleListByDirectory(params).then(res => {
        this.tableData = res.data
      })
    },
    // 批量移除
    handleDirectorySelectionChange(val) {
      this.removeAll = []
      for (let i = 0; i < val.length; i++) {
        if (this.removeAll.indexOf(val[i].id) === -1) {
          this.removeAll.push(val[i].id)
        }
      }
    },
    deleteArticle() {
      const params = {
        id: this.removeMultipleSelection.join(','),
        directory_id: this.mainId
      }
      if (this.removeMultipleSelection.length != 0) {
        this.$confirm('确定要移除当前选择的内容吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false
        }).then(() => {
          this.$http.getArticleRemoveAssociate(params).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功'
              })
              this.getArticleListByDirectory()
            }
          })
        })
      }
    },
    sortArticle(row) {
      this.$prompt('移动到第', '排序', {
        showCancelButton: false,
        inputType: 'number',
        inputPattern: /^\+?[1-9]\d*$/
      }).then(({ value }) => {
        const params = {
          id: row.id,
          sort: value
        }
        this.$http.setArticleSort(params).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '移动到: 第' + value + '位成功'
            })
            this.getArticleListByDirectory()
          }
        })
      })
    },
    editArticle(row) {
      this.$router.push({
        path: 'dataManagementAdd',
        query: { id: row.id }
      })
    },
    searchArticle() {
      if (!this.searchTitle) {
        return
      }
      const params = {
        directory_id: this.mainId,
        title: this.searchTitle
      }
      this.$http.searchArticleListByOtherDirectory(params).then(res => {
        console.log('ttt', res.data)
        this.tableData1 = res.data
      })
    },
    // 批量添加
    handleArticleSelectionChange(val) {
      this.addMultipleSelection = []
      for (let i = 0; i < val.length; i++) {
        if (this.addMultipleSelection.indexOf(val[i].id) === -1) {
          this.addMultipleSelection.push(val[i].id)
        }
      }
    },
    addArticle() {
      if (this.addMultipleSelection.length != 0) {
        const params = {
          id: this.addMultipleSelection.join(','),
          directory_id: this.mainId
        }
        this.$http.getArticleAssociated(params).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '添加分类内容成功'
            })
            this.isShowModal = false
            this.getArticleListByDirectory()
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.sort-management-detail {
  .tuolele-main-search {
    padding-bottom: 20px;
  }
  .add-content-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    .add-content-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #333;
      opacity: 0.7;
    }
  }
  .add-content {
    width: 620px;
    background-color: #ffffff;
    box-shadow: 0px 6px 20px 0px rgba(148, 148, 148, 0.5);
    border-radius: 10px;
    .add-header {
      width: 100%;
      padding: 25px 30px;
      border-bottom: 1px solid #f5f5f5;
      .title {
        font-size: 22px;
        font-weight: normal;
        font-stretch: normal;
        color: #4c84ff;
      }
      .close {
        cursor: pointer;
        img {
          width: 18px;
          height: 18px;
        }
      }
    }
    .el-table tr th {
      background: #fff;
      color: #333;
    }
    .el-table td,
    .el-table th {
      border: 1px solid #ebebeb !important;
    }
  }
  .input1 {
    width: 211px;
    margin-right: 10px;
  }
  .add-content-main {
    display: flex;
    flex-direction: column;
    padding: 30px;
  }
  .add-content-table {
    margin: 20px auto;
  }
  .confirm-btn {
    margin: 50px 0 30px;
    .title {
      color: $color_black;
      margin-bottom: 10px;
      span {
        color: $color_blue;
      }
    }
  }
}
</style>
